import { render, staticRenderFns } from "./dialog-add-recruit.vue?vue&type=template&id=363f465d&scoped=true"
import script from "./dialog-add-recruit.vue?vue&type=script&lang=js"
export * from "./dialog-add-recruit.vue?vue&type=script&lang=js"
import style0 from "./dialog-add-recruit.vue?vue&type=style&index=0&id=363f465d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f465d",
  null
  
)

export default component.exports